var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _circle, _path7, _g3, _path8, _path9, _g4, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeniedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1774",
    "data-name": "Group 1774",
    xmlns: "http://www.w3.org/2000/svg",
    width: 524.67,
    height: 418.271,
    viewBox: "0 0 524.67 418.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7421",
    "data-name": "Path 7421",
    d: "M442.174,400.477a2.269,2.269,0,0,0,1.643-3.934l-.156-.618.062-.148a5.811,5.811,0,0,1,7.571-3.114c9.314,3.851-.52,12.7.22,18.688.259,2.067,8.355,2.18,7.9,4.209a72.282,72.282,0,0,0,6.565-30.023,69.766,69.766,0,0,0-.435-7.783q-.36-3.178-1-6.31a73.12,73.12,0,0,0-14.511-30.985c-3.463-1.891-1.351-4.85-3.1-8.4-.627-1.279-6.218-1.307-6.451-2.709.25.033,3.864-3.721,2.671-5.577a3.077,3.077,0,0,1,.468-3.82,3.21,3.21,0,0,0,.278-.326c2.981-4.044,7.09-3.34,9.237,2.154,4.583,2.311,4.629,6.146,1.818,9.836-1.788,2.347-2.033,5.523-3.6,8.036.162.207.33.407.491.613a73.59,73.59,0,0,1,7.685,12.166,30.593,30.593,0,0,1,1.822-14.21c1.759-4.248,5.07-7.822,7.969-11.5a6.248,6.248,0,0,1,11.123,3.16q.009.08.017.16-.643.363-1.259.771a3.078,3.078,0,0,0,1.244,5.6l.063.01c-.155,1.544-5.633,6.407-6.02,7.912,3.705,14.308.933,16.2-10.466,16.437l-.6.852a75.174,75.174,0,0,1,3.884,18.556,71.244,71.244,0,0,1-.048,11.5l.019-.136a18.826,18.826,0,0,1,6.423-10.872c4.944-4.064,11.931-5.563,17.265-8.83a3.533,3.533,0,0,1,5.412,3.435l-.022.143a20.673,20.673,0,0,0-2.318,1.118q-.644.364-1.26.772a3.077,3.077,0,0,0,1.245,5.6l.063.01.129.019c-1.362,3.236-14.336,7.8-16.711,10.392-2.31,12.5-1.175,12.126-11.811,8.49h-.006a75.092,75.092,0,0,1-5.039,14.728l-18.02.006c-.065-.2-.123-.407-.181-.607a20.474,20.474,0,0,0,4.986-.3c-1.338-1.64-2.675-3.293-4.013-4.933a1.122,1.122,0,0,1-.084-.1l-.02-.025-1.855-6.107a30.774,30.774,0,0,1,.71-4.021h0Z",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7422",
    "data-name": "Path 7422",
    d: "M251.744,416.42l-159.457.055a22.112,22.112,0,0,1-19.2-33.233l79.678-145.049a22.16,22.16,0,0,1,38.382-.013l79.788,145.012a22.159,22.159,0,0,1-19.189,33.228h0ZM72.09,394.32c0,3.464,17.6-4,19.418-.845,3.646,6.31-6.509,21,.779,21,0,0,173.27-3.828,176.912-10.141a19.954,19.954,0,0,0-.007-20.16L189.4,239.163a19.946,19.946,0,0,0-17.452-10.055c-7.285,0-99.861,161.749-99.861,165.213h0Z",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7423",
    "data-name": "Path 7423",
    d: "M253.515,414.419c-2,4,91.614,2.771,92.721,2.771,0,0,26.312-.581,26.865-1.54a3.03,3.03,0,0,0,0-3.061l-12.116-22.021a3.029,3.029,0,0,0-2.65-1.527.382.382,0,0,0-.2.119c-16.163,14.444-36.083,23.992-57.757,24.315-23.047.343-46.732.69-46.859.944Z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7424",
    "data-name": "Path 7424",
    d: "M0,417.081a1.186,1.186,0,0,0,1.19,1.19l522.29-.181a1.19,1.19,0,1,0,0-2.38l-522.29.181A1.187,1.187,0,0,0,0,417.081Z",
    fill: "#ccc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1769",
    "data-name": "Group 1769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7425",
    "data-name": "Path 7425",
    d: "M403.878,411.305l-9.045,0-4.315-34.886,13.349,0Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7426",
    "data-name": "Path 7426",
    d: "M372.889,411.111h0a7.766,7.766,0,0,0-.429,2.557h0a3.07,3.07,0,0,0,3.071,3.069l28.01-.01a2.094,2.094,0,0,0,2.094-2.095v-1.166s1.384-3.505-1.47-7.824c0,0-3.544,3.384-8.844-1.912l-1.563-2.83-11.307,8.275-6.268.774c-1.371.169-2.587-.025-3.292,1.163h0Z",
    fill: "#2f2e41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1770",
    "data-name": "Group 1770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7427",
    "data-name": "Path 7427",
    d: "M369.2,381.468l-8.568,2.9L345.369,352.7l12.645-4.279Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7428",
    "data-name": "Path 7428",
    d: "M339.779,391.208h0a7.767,7.767,0,0,0,.412,2.56h0a3.07,3.07,0,0,0,3.892,1.924l26.532-8.98a2.094,2.094,0,0,0,1.312-2.655l-.374-1.1s.189-3.764-3.9-6.942c0,0-2.274,4.341-8.991,1.021l-2.387-2.18-8.061,11.46-5.69,2.741c-1.245.6-2.459.8-2.747,2.156h0Z",
    fill: "#2f2e41"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7429",
    "data-name": "Path 7429",
    d: "M355.226,179.09l-17.543,58.1-20.711,52.261,32.789,74.634,12.158-5.408-14.547-68.56,30.508-46.523,14.236,145.232,12.159-.68,16.49-175.3,2.351-38.168Z",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7430",
    "data-name": "Path 7430",
    d: "M408.21,50.385l-25.668,4.738-2.023,11.485-15.534,7.436-8.077,84.443s-13.5,17.568-2.694,22.969l68.9-6.779s3.373-12.49,0-13.675-3.388-31.02-3.388-31.02l15.516-61.366-22.97-8.1L408.21,50.385Z",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 20.728,
    cy: 20.728,
    r: 20.728,
    transform: "translate(372.342 8.708)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7431",
    "data-name": "Path 7431",
    d: "M406.8,32.512c-1.654.905-.085,5.229-1.118,5.6-1.195.432-5.552-4.527-5.606-10.082-.016-1.681.371-2.488,0-4.482-.487-2.607-1.98-5.683-3.363-5.6-.82.048-1.62,1.207-1.68,2.241-.084,1.449,1.324,2.02,1.121,2.8-.386,1.487-6.3,2.514-8.4,0-1.65-1.969-.385-5.425-1.122-5.6-.544-.13-1.128,1.772-3.36,3.923-.841.81-2.092,2.015-2.8,1.682-1.024-.482-.28-3.876-.562-3.921-.233-.037-.379,2.349-1.679,4.482-1.67,2.741-5.114,4.854-6.721,3.924-.985-.57-1.062-2.156-1.122-3.361-.125-2.538-3.813-8.376-2.859-11.092,1.942-5.526,5.27-1.631,6.775-3.475,2.038-2.5,3.866-1.154,7.281-3.924,3.337-2.706,3.366-5.425,5.6-5.6,2.012-.161,2.728,1.985,5.042,1.679,1.961-.26,2.387-1.924,3.921-1.682,1.4.222,1.5,1.688,3.362,2.24,1.191.352,1.453-.157,2.8,0,2.806.326,4.69,2.881,5.043,3.359,1.361,1.845.833,2.623,2.242,4.481,1.216,1.6,3.909.922,4.922,1.722,3.309,2.614,4.731,7.435,4.76,12.93.02,3.843-.481,5.785-1.6,10.636-.849,3.683-4.782,8.443-6.95,10.566-.582.57-2.214,2.167-3.361,1.682-1.087-.46-1.12-2.528-1.121-2.8,0-.939.245-2.1,2.239-5.043,2.094-3.09,2.926-3.443,2.8-4.483-.224-1.838-3.164-3.521-4.483-2.8h0Z",
    fill: "#2f2e41"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1771",
    "data-name": "Group 1771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7432",
    "data-name": "Path 7432",
    d: "M334.495,225.76c-.645,5.4,1.619,10.115,5.057,10.526s6.748-3.636,7.393-9.039a13.619,13.619,0,0,0-.68-6.4l2.446-22.927-10.783-.919-1.267,22.7a13.618,13.618,0,0,0-2.166,6.055h0Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7433",
    "data-name": "Path 7433",
    d: "M365.491,73.5s-5.587.079-9.286,7.3c-1.966,3.839-12.482,75.628-12.482,75.628l-9.687,58.808,16.5.083L363.4,159.628l10.817-32.3L365.491,73.5Z",
    fill: "#e6e6e6"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7434",
    "data-name": "Path 7434",
    d: "M411.93,217.13c-1.58,5.207-.175,10.242,3.138,11.248s7.28-2.4,8.86-7.606a13.619,13.619,0,0,0,.449-6.415l6.419-22.145L420.34,189.42l-5.218,22.127a13.619,13.619,0,0,0-3.192,5.583h0Z",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7435",
    "data-name": "Path 7435",
    d: "M423.416,69.632s8.1-6.082,14.863,3.372,9.487,87.139,9.487,87.139l-18.9,47.968-14.188-4.724,13.49-58.775-23.659-44.576,18.9-30.4Z",
    fill: "#e6e6e6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1773",
    "data-name": "Group 1773"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 73,
    cy: 73,
    r: 73,
    transform: "translate(145.48 238.431)",
    fill: "#ef3054"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1772",
    "data-name": "Group 1772"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 6.703,
    cy: 6.703,
    r: 6.703,
    transform: "translate(211.79 342.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7436",
    "data-name": "Path 7436",
    d: "M218.464,266.681c-.616,4.091.487,4.947.494,22.585s3.666,41.286-.471,41.287-5.65-48.8-20.017-53.122c-16.891-5.078,21.988-23.994,19.995-10.75Z",
    fill: "#fff"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7437",
    "data-name": "Path 7437",
    d: "M120.5,348.7l-6.6,13.935c7.973-5.717,20.427-10.646,30.338-13.286-9.234-4.46-20.533-11.652-27.284-18.772l3.793,14.724c-44.474-9.059-76.411-43.177-76.425-82.259l-1.606-.553C42.738,303.315,74.234,339.453,120.5,348.7Z",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeniedImg);
export default __webpack_public_path__ + "static/media/denied-img.c8841feb374c4d94b43f1b5da9fe358a.svg";
export { ForwardRef as ReactComponent };